import React, { useState } from 'react';
import IuguV2 from './IuguV2';          // ✅ Novo componente V2 com dual tokenization
import PixPaymentButton from './PixPaymentButton';  // ✅ Novo componente PIX

/**
 * CardPayment - Wrapper V2 com seletor de método de pagamento
 *
 * Permite usuário escolher entre:
 * - Cartão de Crédito (IuguV2 - dual tokenization Vindi + Iugu)
 * - PIX (PixPaymentButton)
 *
 * @version 2.0.0
 */
const CardPayment = ({ selectedpaymentplan, form, goToStep, payments }) => {
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('credit_card');

  return (
    <>
      {/* V2: Payment Method Selector */}
      <div className="payment-method-selector" style={{
        display: 'flex',
        gap: '10px',
        marginBottom: '0.2rem',
        padding: '0 1rem',
      }}>
        <button
          className={selectedPaymentMethod === 'credit_card' ? 'payment-method-button active' : 'payment-method-button'}
          onClick={() => setSelectedPaymentMethod('credit_card')}
          style={{
            flex: 1,
            padding: '12px',
            border: selectedPaymentMethod === 'credit_card' ? '2px solid #22d68a' : '2px solid #ddd',
            borderRadius: '8px',
            background: selectedPaymentMethod === 'credit_card' ? '#f0fdf4' : 'white',
            cursor: 'pointer',
            fontSize: '0.875rem',
            fontWeight: '600',
            color: selectedPaymentMethod === 'credit_card' ? '#22d68a' : '#666',
            transition: 'all 0.2s',
          }}
          type="button"
        >
          Cartão de Crédito
        </button>

        <button
          className={selectedPaymentMethod === 'pix' ? 'payment-method-button active' : 'payment-method-button'}
          onClick={() => setSelectedPaymentMethod('pix')}
          style={{
            flex: 1,
            padding: '12px',
            border: selectedPaymentMethod === 'pix' ? '2px solid #22d68a' : '2px solid #ddd',
            borderRadius: '8px',
            background: selectedPaymentMethod === 'pix' ? '#f0fdf4' : 'white',
            cursor: 'pointer',
            fontSize: '0.875rem',
            fontWeight: '600',
            color: selectedPaymentMethod === 'pix' ? '#22d68a' : '#666',
            transition: 'all 0.2s',
          }}
          type="button"
        >
          PIX
        </button>
      </div>

      {/* Render appropriate component based on selection */}
      {selectedPaymentMethod === 'credit_card' ? (
        <IuguV2
          form={form}
          selectedpaymentplan={selectedpaymentplan}
          goToStep={goToStep}
        />
      ) : (
        <PixPaymentButton
          form={form}
          selectedpaymentplan={selectedpaymentplan}
          goToStep={goToStep}
        />
      )}
    </>
  );
};

export default CardPayment;
